const OPTIONS = [["month", "Monthly"], ["year", "Yearly"]];

export const savingsPct = (m, y) => (((m * 12 - y) / (m * 12)) * 100).toFixed(2);

export const PlanToggle = ({ value, onChange }) => (
  <div className="inline-flex rounded-full border border-line bg-inset p-1" role="tablist" data-testid="plan-interval-toggle">
    {OPTIONS.map(([k, label]) => (
      <button
        key={k}
        role="tab"
        aria-selected={value === k}
        onClick={() => onChange(k)}
        data-testid={`plan-interval-${k}`}
        className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 ${
          value === k ? "bg-amber-500 text-onaccent" : "text-slate-400 hover:text-amber-200"
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);
